import { Alert, Button, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

/**
 * Erscheint, sobald eine Jira-Antwort 409 JIRA_REAUTH_REQUIRED war.
 *
 * `message` trägt die Begründung, wo es eine gibt (etwa: das Token gilt für
 * mehrere Sites, und keine davon ist die konfigurierte). Ohne sie stünde hier
 * der allgemeine Text, und der Lead wüsste nicht, was er beim Zustimmen anders
 * machen soll. Der Aufrufer reicht sie **bereits übersetzt** herein — die API
 * nennt den Fall über `siteProblemCode`, ihr eigener Text ist deutsch und nur
 * der Rückfall für einen Fall ohne Code.
 */
export function ReconnectBanner({ message }: { message?: string }) {
  const { t } = useTranslation();
  return (
    <Alert color="yellow" title={t("pages.customerView.cockpit.reconnectTitle")}>
      <Group justify="space-between" wrap="wrap">
        <Text size="sm">{message ?? t("pages.customerView.cockpit.reconnectText")}</Text>
        <Button size="xs" component="a" href="/api/v1/customer-view/connect/login">
          {t("pages.customerView.connectButton")}
        </Button>
      </Group>
    </Alert>
  );
}
